/*
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-03-31 13:00:48
 * @LastEditors: xst
 * @LastEditTime: 2020-04-07 12:06:18
 */

export default {
  state: {
    isCollapse: false,
    logoShow: true,
    titleShow:false,
    uniquerouter: true,
    rightNav: {},
    tabnavBox: [
      {
        title: 'home',
        path: '/index'
      }
    ]
  },
  mutations: {
    addTab (state, arg) {
      state.isActive = arg.path
      for (let i = 0; i < state.tabnavBox.length; i++) {
        if (state.tabnavBox[i].path === arg.path) {
          return false
        }
      }
      state.tabnavBox.push({
        title: arg.title,
        path: arg.path
      })
      this.dispatch('setTabnavBox', state.tabnavBox)
    },
    alltabnavBox (state, arg) {
      state.tabnavBox = arg
    },
    setTabnavBox (state, arg) {
      sessionStorage.setItem('tabnavBox',JSON.stringify(arg))
    },
    openMenu (state, arg) {
      state.rightNav = arg
    },
    removeTab (state, arg) {
      let index = state.tabnavBox.findIndex(function (value, key) {
        return value.path === arg.tabItem.path
      })
      state.tabnavBox.splice(index, 1)
      if (arg.tabItem.path === arg.fullPath) {
        let tabActive = state.tabnavBox[index] || state.tabnavBox[index - 1]
        arg.router.push(tabActive.path)
      }
      this.dispatch('setTabnavBox', state.tabnavBox)
    },
    removeOtherTab (state, arg) {
      state.tabnavBox = [{
        title: 'home',
        path: '/index'
      }]
      if (arg.all) {
        arg.router.push('/index')
        this.dispatch('setTabnavBox', state.tabnavBox)
        return false
      }
      state.tabnavBox.push(arg.tabItem)
      arg.router.push(arg.tabItem.path)
      this.dispatch('setTabnavBox', state.tabnavBox)
    },
    collapse (state, arg) {
      state.isCollapse = !state.isCollapse
      if(state.titleShow){
        setTimeout(function(){
          state.titleShow=false
        },300)
      }else{
        state.titleShow=true
      }

    },
  },
  actions: {
    addTab ({commit}, arg) {
      commit('addTab', arg)
    },
    alltabnavBox ({commit}, arg) {
      commit('alltabnavBox', arg)
    },
    setTabnavBox ({commit}, arg) {
      commit('setTabnavBox', arg)
    },
    openMenu ({commit}, arg) {
      commit('openMenu', arg)
    },
    removeTab ({commit}, arg) {
      commit('removeTab', arg)
    },
    removeOtherTab ({commit}, arg) {
      commit('removeOtherTab', arg)
    },
    collapse ({commit}, arg) {
      commit('collapse', arg)
    },
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/layout/index.js